module.exports = __webpack_public_path__ + "assets/img/mecha-f7642613.png";